import { Icon } from '@/shared/assets/icons';
import { useThemeStore } from '@/shared/lib/theme';
import type { FC } from 'react';

/**
 * Light/dark switch, sat to the left of the user avatar in the header. Renders
 * nothing in production — see `useThemeStore`.
 */
export const ThemeToggle: FC = () => {
  const isAvailable = useThemeStore((state) => state.isThemeToggleAvailable);
  const theme = useThemeStore((state) => state.theme);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);

  if (!isAvailable) return null;

  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <button
      type="button"
      className="text-primary-inverse hover:bg-primary-7 flex h-10 w-10 items-center justify-center rounded-full transition-colors"
      title={label}
      aria-label={label}
      aria-pressed={isDark}
      onClick={toggleTheme}
    >
      {/* Shows the mode you'd switch *to*, which is how the OS toggles read. */}
      <Icon size={22} name={isDark ? 'sun' : 'moon'} />
    </button>
  );
};
